import React, { Component } from "react";
import { Icon } from "@iconify/react";
import roundCancel from "@iconify/icons-ic/round-cancel";
import roundCheckCircle from "@iconify/icons-ic/round-check-circle";
import CustomButton from "../components/CustomButton";
import { NumericFormat } from "react-number-format";
import qs from "qs";
import { ImpulseSpinner } from "react-spinners-kit";

export default class PaymentResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MID: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .MID,
      TerminalId: qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).TerminalId,
      RefNum: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .RefNum,
      ResNum: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .ResNum,
      State: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .State,
      TraceNo: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .TraceNo,
      Amount: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .Amount,
      Wage: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .Wage,
      Rrn: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .Rrn,
      SecurePan: qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).SecurePan,
      Token: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .Token,
      HashedCardNumber: qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).HashedCardNumber,
      Status: qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        .Status,
      Text: "فرایند تراکنش تکمیل نشد",
      WhatFor: "-",
      loading: true,
      verifySuccess: false,
    };

    this.getCookie = this.getCookie.bind(this);
    // console.log(this.state.TraceNo);
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    let data = {
      mobile: this.getCookie("gomenu_user_mobile"),
      token: this.getCookie("gomenu_user_token"),
      transactionType: "orderSettlement",
      MID: this.state.MID ? this.state.MID : null,
      state: this.state.State ? this.state.State : null,
      status: this.state.Status ? this.state.Status : null,
      RRN: this.state.Rrn ? this.state.Rrn : null,
      refNum: this.state.RefNum ? this.state.RefNum : null,
      resNum: this.state.ResNum ? this.state.ResNum : null,
      TerminalId: this.state.TerminalId ? this.state.TerminalId : null,
      traceNo: this.state.TraceNo ? this.state.TraceNo : null,
      amount: this.state.Amount ? this.state.Amount : null,
      wage: this.state.Wage ? this.state.Wage : null,
      securePan: this.state.SecurePan ? this.state.SecurePan : null,
      hashedCardNumber: this.state.HashedCardNumber
        ? this.state.HashedCardNumber
        : null,
      businessCode: this.props.match.params.code,
    };
    console.log(data);
    // this.setState({ verifySuccess: true, loading: false });
    // return;
    fetch("https://api.sepandplus.ontco.com/publicapi/getPaymentResult", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 521 || result.status === 522) {
          this.setState({ Text: result.message });
        } else {
          if (result.status === 200) {
            this.setState({ verifySuccess: true });
            // let time = "";
            // switch (result.packageInfo[0].duration.toString()) {
            //   case "31": {
            //     time = "1 ماهه";
            //     break;
            //   }
            //   case "183": {
            //     time = "6 ماهه";
            //     break;
            //   }
            //   case "365": {
            //     time = "1 ساله";
            //     break;
            //   }
            //   default:
            //     break;
            // }

            // this.setState({
            //   WhatFor: result.packageInfo[0].title + " " + time,
            // });
          }
          switch (Number(this.state.Status)) {
            case 1: {
              this.setState({ Text: "کاربر انصراف داده است" });
              break;
            }
            case 2: {
              this.setState({ Text: "پرداخت با موفقیت انجام شد" });
              break;
            }
            case 3: {
              this.setState({ Text: "پرداخت انجام نشد" });
              break;
            }
            case 4: {
              this.setState({
                Text: "کاربر در بازه زمانی تعیین شده پاسخی ارسال نکرده است",
              });
              break;
            }
            case 5: {
              this.setState({ Text: "پارامترهای ارسالی نامعتبر است" });
              break;
            }
            case 8: {
              this.setState({ Text: "آدرس سرور پذیرنده نامعتبر است" });
              break;
            }
            case 10: {
              this.setState({ Text: "توکن ارسال شده یافت نشد" });
              break;
            }
            case 11: {
              this.setState({
                Text: "با این شماره ترمینال فقط تراکنش‌های توکنی قابل پرداخت هستند",
              });
              break;
            }
            case 12: {
              this.setState({ Text: "شماره ترمینال ارسال شده یافت نشد" });
              break;
            }

            default:
              break;
          }
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  onRedirect() {
    // if (isUser) {
    //   this.props.history.push("/Restaurants/" + this.props.match.params.id);
    // } else {
    //   this.props.history.push("/Restaurants");
    // }

    this.props.history.push(
      "/" + this.props.match.params.code + "/" + this.props.match.params.id
    );
  }
  render() {
    if (!this.state.loading) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100vh",
            textAlign: "center",
          }}
        >
          <div
            style={{
              margin: "0px 10px",
              borderRadius: "8px",
              border: "2px solid var(--brown1)",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "280px",
              maxWidth: "400px",
            }}
          >
            {this.state.verifySuccess && (
              <Icon
                icon={roundCheckCircle}
                style={{ color: "var(--green1)" }}
                width="80px"
              />
            )}

            {!this.state.verifySuccess && (
              <Icon
                icon={roundCancel}
                style={{ color: "var(--red1)" }}
                width="80px"
              />
            )}

            <div
              style={{
                fontSize: "20px",
                color: !this.state.verifySuccess
                  ? "var(--red1)"
                  : "var(--green1)",
                margin: "20px 0px",
                lineHeight: "40px",
              }}
            >
              {this.state.Text}
            </div>
            {this.state.verifySuccess && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--gray6)",
                  fontSize: "16px",
                  marginBottom: "20px",
                }}
              >
                از خرید شما متشکریم. تا دقایقی دیگر سفارش شما آماده می‌شود.
              </div>
            )}
            {/* {this.state.TraceNo && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--gray6)",
                  fontSize: "16px",
                  marginBottom: "20px",
                }}
              >
                <div>کد پیگیری: </div>
                <div style={{ marginRight: "10px" }}>{this.state.TraceNo}</div>
              </div>
            )} */}

            {this.state.verifySuccess && (
              <div
                style={{
                  width: "100%",
                  minHeight: "1px",
                  backgroundColor: "var(--gray3)",
                  marginBottom: "20px",
                }}
              />
            )}

            {this.state.verifySuccess && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "var(--gray6)",
                  width: "100%",
                  marginBottom: "10px",
                  fontSize: "14px",
                }}
              >
                <div>کد پیگیری: </div>
                <div style={{ marginRight: "10px" }}>
                  {this.state.TraceNo ? this.state.TraceNo : "-"}
                </div>
              </div>
            )}

            {this.state.verifySuccess && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "var(--gray6)",
                  width: "100%",
                  marginBottom: "40px",
                  fontSize: "14px",
                }}
              >
                <div>مبلغ پرداختی: </div>
                <NumericFormat
                  value={this.state.Amount}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" ریال"}
                  style={{ marginRight: "10px" }}
                />
              </div>
            )}

            <CustomButton
              title="بازگشت به صفحه اصلی"
              minHeight="35px"
              onClick={this.onRedirect.bind(this)}
            />
          </div>
        </div>
      );
    } else
      return (
        <div className="loadingStyle">
          <ImpulseSpinner
            size={50}
            frontColor="var(--brown1)"
            backColor="var(--gray1)"
            loading={true}
          />
        </div>
      );
  }
}
